import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useLoginResult } from "../State/LoginResultContext";
import { showToast } from "../utils/toast";

export default function Signout() {
  const { updateloginResults } = useLoginResult();
  const navigate = useNavigate();
  const didShowToast = useRef(false);

  useEffect(() => {
    updateloginResults(null);
    if (!didShowToast.current) {
      didShowToast.current = true;
      showToast("You've been signed out.", { type: "success" });
    }
    navigate("/loginregister");
  }, [updateloginResults, navigate]);

  return <></>;
}
